import { render, staticRenderFns } from "./VPageNavItem.vue?vue&type=template&id=42373692&"
import script from "./VPageNavItem.vue?vue&type=script&lang=js&"
export * from "./VPageNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports